import { inject, Injectable } from '@angular/core';

import { ImportSkillsCacheService } from '@core/tellent-skills-logic';
import { ImportSkillsStepDefinition } from '@core/tellent-skills-types';

@Injectable({ providedIn: 'root' })
export class ImportSkillsFlowStepService {
  private readonly cacheService = inject(ImportSkillsCacheService);

  public readonly flowSteps: ImportSkillsStepDefinition[] = [
    {
      step: 'intro',
      canMatch: () => !this.cacheService.getDontShowIntroFlag(),
    },
    { step: 'upload_file' },
    { step: 'loading' },
    { step: 'summary' },
    { step: 'result' },
  ];
}
